<template>
  <div class="massive-info-cards">
    <v-row>
      <v-col cols="12" md="4">
        <v-card class="info-card" outlined elevation="1">
          <v-card-text class="pa-4">
            <div class="d-flex align-center">
              <v-icon size="32" color="amber darken-1" class="mr-3">mdi-file-excel</v-icon>
              <div>
                <div class="text-subtitle-1 font-weight-medium">{{ $t('massive.infoCards.formatAllowed') }}</div>
                <div class="text-body-2 text--secondary">{{ $t('massive.infoCards.formatAllowed.text') }}</div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="info-card" outlined elevation="1">
          <v-card-text class="pa-4">
            <div class="d-flex align-center">
              <v-icon size="32" color="teal darken-1" class="mr-3">mdi-file-document-outline</v-icon>
              <div>
                <div class="text-subtitle-1 font-weight-medium">{{ $t('massive.infoCards.maxSize') }}</div>
                <div class="text-body-2 text--secondary">{{ $t('massive.infoCards.maxSize.text') }}</div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="info-card" outlined elevation="1">
          <v-card-text class="pa-4">
            <div class="d-flex align-center">
              <v-icon size="32" color="indigo darken-1" class="mr-3">mdi-information</v-icon>
              <div>
                <div class="text-subtitle-1 font-weight-medium">{{ $t('massive.infoCards.information') }}</div>
                <div class="text-body-2 text--secondary">{{ $t('massive.infoCards.information.text') }}</div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'MassiveInfoCards'
};
</script>

<style lang="css" scoped>
.massive-info-cards {
  margin-bottom: 24px;
}

.info-card {
  height: 100%;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.info-card .text-subtitle-1 {
  word-break: break-word;
  line-height: 1.3;
}

.info-card .text-body-2 {
  word-break: break-word;
  line-height: 1.4;
}
</style>
